import html from '../index.html'; // eslint-disable-line no-unused-vars
import styles from '../stylesheets/main.scss'; // eslint-disable-line no-unused-vars

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// i18n goes before configureStore load;
import i18n from './libs/i18n.js';
const lang = navigator.language || navigator.userLanguage;
i18n.setLocale(lang);

import setVisitedCookie from './libs/visitedCookie.js';

import configureStore from './libs/configureStore.js';
import App from './components/App.jsx';

setVisitedCookie();

const store = configureStore();

ReactDOM.render((
  <Provider store={store}>
    <App lang={lang} />
  </Provider>
), document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./web/js/index.js
 **/